export class SearchFilterModel<TModel> {
    public Filter: TModel;
    public ExtraFilters: any;
    public Page: number;
}